module.exports = __webpack_public_path__ + "25bd123c2333b53e28df2faed616fa0f.svg";